import { useState, useEffect } from 'react';

export const useCallDuration = (isCallActive: boolean) => {
  const [callDuration, setCallDuration] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isCallActive) {
      interval = setInterval(() => {
        setCallDuration(prev => prev + 1);
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isCallActive]);

  const resetDuration = () => setCallDuration(0);

  return { callDuration, resetDuration };
};